import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[allowNegativeFirst]'
})
export class AllowNegativeFirstDirective {

  /**
   * Funciona em conjunto com a diretiva currencyMask e options = { allowNegative: true }
   * @param event 
   */
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.key === '-') {
      const input = event.target as HTMLInputElement;

      // Permite o "-" somente se:
      // - Não tiver valor ainda
      // - Cursor estiver no início
      const isFirstPosition = input.selectionStart === 0;
      const isEmpty = !input.value;

      if (isEmpty || isFirstPosition) {
        input.value = '-'; // ✅ deixa digitar o "-"
      }

      event.preventDefault(); // ❌ bloqueia em qualquer outro ponto
    }
  }
}
